/**
 * @file why
 * @author 丁聪
 */

import React, { Component } from 'react'
import './index.scss'

class Banner extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div id="why">
                <div className='why-wrap'>
                    <img className='why-img' width='120px' alt='xcx' src='http://hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-official/popup/wxapp.jpg'></img>
                </div>
                {/* <div className="text">
                    <div className="left">
                        <p>本测试卷是由汉语言研究及汉语国际教育领域的专家依据海外华裔青少儿的学习特点和中文水平，专门设计出的“青少儿中文能力标准化测评”试题。</p>
                        <br />
                        <p>每一套试卷包含“语言交际能力”、“话题任务内容”、“语言量化指标”等三个方面内容；通过听说读写四个维度，对孩子的中文水平进行综合评估，客观地测试出您孩子当前的中文水平。以便根据测试结果，有针对性地为您的孩子定制专业、系统的中文学习计划。</p>
                    </div>
                    <div className="right">
                        <div className="first">
                            <div className="number">1</div>
                            <div className="world">打开微信，扫一扫添加微信小程序</div>
                        </div>
                        <div className="two"></div>
                        <div className="three">
                            <div className="number2">2</div>
                            <div className="world">点击就能测试啦！</div>
                        </div>
                    </div>
                </div> */}
            </div>
        )
    }
}

export default Banner
